import { dynamicDocInstance } from '@/api/dynamic/dynamic-document-instance';
import { CoordinateAxi } from '@/types/dynamicDoc';

/** Координатная ось */
export const coordinateAxi = {
    getCoordinateAxiByWorkTypeIdRange: (data: string[]): Promise<CoordinateAxi[]> =>
        dynamicDocInstance.post<CoordinateAxi[]>('Work/GetCoordinateAxiByWorkTypeIdRange', data).then(x => x.data),
};
